import { useDevices, DeviceType } from "@100mslive/react-sdk";

const DeviceSettings = () => {
  const { allDevices, selectedDeviceIDs, updateDevice } = useDevices();
  const { videoInput, audioInput, audioOutput } = allDevices;
  return (
    <div className="w-full h-full rounded-xl p-4 lg:p-8 bg-gray-800 space-y-6">
      <h1 className="text-white font-medium text-md lg:text-xl">Device Settings</h1>
      <div className="space-y-4">
        <Select
          title="Camera"
          value={selectedDeviceIDs.videoInput}
          list={videoInput}
          onChange={(e: any) =>
            updateDevice({
              deviceId: e.target.value,
              deviceType: DeviceType.videoInput,
            })
          }
        />
        <Select
          title="Microphone"
          value={selectedDeviceIDs.audioInput}
          list={audioInput}
          onChange={(e: any) =>
            updateDevice({
              deviceId: e.target.value,
              deviceType: DeviceType.audioInput,
            })
          }
        />
        <Select
          title="Speaker"
          value={selectedDeviceIDs.audioOutput}
          list={audioOutput}
          onChange={(e: any) =>
            updateDevice({
              deviceId: e.target.value,
              deviceType: DeviceType.audioOutput,
            })
          }
        />
      </div>
    </div>
  );
};

const Select = ({ list, value, onChange, title }: any) => {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-6 space-y-4 lg:space-y-0 lg:space-x-4">
      <span className="text-white col-span-1 font-medium text-sm flex items-center">
        {title}
      </span>
      {list?.length ? (
        <div className="grid col-span-5">
          <svg
            className="pointer-events-none z-10 right-1 relative col-start-1 row-start-1 h-4 w-4 self-center justify-self-end forced-colors:hidden"
            viewBox="0 0 16 16"
            fill="currentColor"
            aria-hidden="true"
          >
            <path
              fill-rule="evenodd"
              d="M4.22 6.22a.75.75 0 0 1 1.06 0L8 8.94l2.72-2.72a.75.75 0 1 1 1.06 1.06l-3.25 3.25a.75.75 0 0 1-1.06 0L4.22 7.28a.75.75 0 0 1 0-1.06Z"
              clip-rule="evenodd"
            ></path>
          </svg>
          <select
            onChange={onChange}
            value={value}
            className="appearance-none px-4 py-3 forced-colors:appearance-auto border row-start-1 col-start-1 rounded-xl bg-slate-50 dark:bg-slate-800 hover:border-cyan-500 dark:hover:border-cyan-700 hover:bg-white dark:hover:bg-slate-700 border-slate-300 dark:border-slate-600 text-slate-700 dark:text-slate-200 text-sm"
          >
            {list.map((device: any) => (
              <option value={device.deviceId} key={device.deviceId}>
                {device.label}
              </option>
            ))}
          </select>
        </div>
      ) : null}
    </div>
  );
};

export default DeviceSettings;
